export default __webpack_public_path__ + "static/media/finanical-services-fundcard.8a1c1f34.png";